(() => {
  const protectedMediaSelector = '[data-pdp-protected-media]';

  const activateProtection = (root) => {
    root.querySelectorAll(`${protectedMediaSelector} img`).forEach((image) => {
      image.draggable = false;
    });

    const preventProtectedMediaAction = (event) => {
      if (event.target?.closest?.(protectedMediaSelector)) {
        event.preventDefault();
      }
    };

    root.addEventListener('contextmenu', preventProtectedMediaAction);
    root.addEventListener('dragstart', preventProtectedMediaAction);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => activateProtection(document), { once: true });
  } else {
    activateProtection(document);
  }
})();
